import { Typography } from "@mui/material";
import { AsyncSelect } from "../../../../../components/forms";
import { OperacionLCSLHPTIFields, OperacionLCSLHPTITablaValorFields } from "../types/fields";
import { EntityWithIdAndDescriptionFields } from "src/types";

interface TablaValorCeldaLCSLHPTIProps {
    control: any;
    index: number; // indice en el array plano de tablaValores lo necesita para acceder al fieldarray
    tipoSelector: 'concentracion' | 'limite_perdida' | 'limite_holding' | 'limite_credito';
    loadOptionsMapping: Record<string, any>;
    permiteEditar: boolean;
}

const TablaValorCeldaLCSLHPTI = ({ control, index, tipoSelector, loadOptionsMapping, permiteEditar }: TablaValorCeldaLCSLHPTIProps) => {
    const loadOptions = loadOptionsMapping[tipoSelector];

    return (
        <AsyncSelect
            name={`${OperacionLCSLHPTIFields.TablaValores}.${index}.${OperacionLCSLHPTITablaValorFields.Valor}`}
            loadOptions={loadOptions}
            valueField={EntityWithIdAndDescriptionFields.Description}
            control={control}
            selectNotNulleable
            fullWidth
            disabled={!permiteEditar}
            size="small"
        />
    );
};

export default TablaValorCeldaLCSLHPTI